/* eslint-disable react-refresh/only-export-components -- this module exports the router, not a component */
import { lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AppLayout } from '@/components/AppLayout'
import { NotFound } from '@/components/NotFound'
import { RequireCapability } from '@/components/RequireCapability'
import { OrdersListPage } from '@/features/orders/OrdersListPage'
import { OrderDetailPage } from '@/features/orders/OrderDetailPage'

// Secondary routes are code-split so the heavy dashboard (recharts) and admin
// screens don't weigh down the initial bundle.
const DashboardPage = lazy(() =>
  import('@/features/dashboard/DashboardPage').then((m) => ({ default: m.DashboardPage })),
)
const RouteTemplatesPage = lazy(() =>
  import('@/features/routes/RouteTemplatesPage').then((m) => ({ default: m.RouteTemplatesPage })),
)
const RouteTemplateDetailPage = lazy(() =>
  import('@/features/routes/RouteTemplateDetailPage').then((m) => ({
    default: m.RouteTemplateDetailPage,
  })),
)
const AdminPage = lazy(() =>
  import('@/features/admin/AdminPage').then((m) => ({ default: m.AdminPage })),
)
const AssistantPage = lazy(() =>
  import('@/features/assistant/AssistantPage').then((m) => ({ default: m.AssistantPage })),
)

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      { index: true, element: <Navigate to="/orders" replace /> },
      { path: 'orders', element: <OrdersListPage /> },
      { path: 'orders/:id', element: <OrderDetailPage /> },
      {
        path: 'dashboard',
        element: (
          <RequireCapability capability="dashboard.view">
            <DashboardPage />
          </RequireCapability>
        ),
      },
      {
        path: 'routes',
        element: (
          <RequireCapability capability="routes.manage">
            <RouteTemplatesPage />
          </RequireCapability>
        ),
      },
      {
        path: 'routes/:id',
        element: (
          <RequireCapability capability="routes.manage">
            <RouteTemplateDetailPage />
          </RequireCapability>
        ),
      },
      {
        path: 'admin',
        element: (
          <RequireCapability capability="admin.users">
            <AdminPage />
          </RequireCapability>
        ),
      },
      { path: 'assistant', element: <AssistantPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
])
